import React from 'react';
import { Quote, Star } from 'lucide-react';

const testimonials = [
  {
    quote: 'We greatly benefited from iTMunch\'s digital expertise, partnering with them as advisors. Their guidance generated consistent leads and unlocked new growth opportunities for our company.',
    name: 'Sarah Mitchell',
    role: 'Marketing Manager',
    company: 'Security & Investigations',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?crop=faces&cs=srgb&fm=jpg&q=85&w=120&h=120',
    rating: 5,
  },
  {
    quote: 'The collaboration with iTMunch has helped us overcome the challenge of linking marketing investments with sales. We now leverage customer data for targeted digital strategies.',
    name: 'Marcus Chen',
    role: 'Global Sales Manager',
    company: 'Renewable Energy',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=faces&cs=srgb&fm=jpg&q=85&w=120&h=120',
    rating: 5,
  },
  {
    quote: 'We collaborated with iTMunch to devise and execute a digital marketing and sales strategy, which proved highly effective over three years. This approach enhanced our brand significantly.',
    name: 'Alexandra Dubois',
    role: 'CEO',
    company: 'Consumer Services',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=faces&cs=srgb&fm=jpg&q=85&w=120&h=120',
    rating: 5,
  },
  {
    quote: 'We have worked together with iTMunch to increase our digital presence. Their knowledge of search and analysis has been of the highest quality and increased our visibility.',
    name: 'Daniel Park',
    role: 'SEM / SEO Specialist',
    company: 'Retail Technology',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?crop=faces&cs=srgb&fm=jpg&q=85&w=120&h=120',
    rating: 5,
  },
  {
    quote: 'iTMunch\'s B2B content syndication services transformed our lead generation strategy. The quality of leads and engagement rates exceeded our expectations significantly.',
    name: 'Rachel Torres',
    role: 'VP of Marketing',
    company: 'Enterprise Software',
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?crop=faces&cs=srgb&fm=jpg&q=85&w=120&h=120',
    rating: 5,
  },
  {
    quote: 'Working with iTMunch as our content syndication vendor has been a game-changer. Their network and expertise helped us reach decision-makers we couldn\'t access before.',
    name: 'James Rodriguez',
    role: 'Director, Demand Generation',
    company: 'Cloud Computing',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?crop=faces&cs=srgb&fm=jpg&q=85&w=120&h=120',
    rating: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 md:py-32 bg-white"
      aria-label="Client Testimonials"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="inline-block text-sm font-semibold tracking-wide uppercase text-[#4AC5DB] mb-4">
            Testimonials
          </span>
          <h2
            data-testid="testimonials-heading"
            className="font-['Outfit'] text-3xl md:text-5xl font-semibold text-slate-900 tracking-tight"
          >
            What Our Clients Say
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">
            Trusted by industry leaders worldwide
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-card-${i}`}
              className="group relative bg-white rounded-2xl p-6 md:p-8 border border-slate-100 hover:border-[#4AC5DB]/20 transition-all duration-300 hover:shadow-lg"
            >
              <Quote className="w-8 h-8 text-[#4AC5DB]/20 mb-4" strokeWidth={1.5} />

              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, starIdx) => (
                  <Star
                    key={starIdx}
                    className="w-4 h-4 fill-amber-400 text-amber-400"
                  />
                ))}
              </div>

              <blockquote className="text-sm md:text-base text-slate-600 leading-relaxed mb-6">
                "{t.quote}"
              </blockquote>

              <div className="flex items-center gap-3 pt-4 border-t border-slate-50">
                <img
                  src={t.image}
                  alt={`${t.name}, ${t.role} at ${t.company}`}
                  className="w-10 h-10 rounded-full object-cover border-2 border-slate-100"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-semibold text-slate-900">{t.name}</p>
                  <p className="text-xs text-slate-500">{t.role} &middot; {t.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
